// Per-browser preference for the supplier-portal ⓘ info tips. Stored in
// localStorage so it persists for the supplier on this device. InfoIcon
// subscribes to the custom event, so toggling from the account menu hides
// or shows every ⓘ across the portal at once.

const KEY = 'sp_info_tips_off';
const EVENT = 'sp:info-tips';

export const infoTipsEnabled = () => {
  try { return typeof window !== 'undefined' && window.localStorage.getItem(KEY) !== '1'; }
  catch { return true; }
};

export const setInfoTipsEnabled = (on) => {
  try { window.localStorage.setItem(KEY, on ? '0' : '1'); } catch { /* private mode / SSR */ }
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(EVENT));
};

// Subscribe to changes; returns an unsubscribe fn.
export const onInfoTipsChange = (handler) => {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};
